import { pipe } from "fp-ts/lib/function";
import { array, option } from "fp-ts/lib";
import {
    RoadblockAwaitableEntityCategory_order,
    TRoadblockAwaitableEntity,
    TRoadblockAwaitableEntityCategory,
} from "../../../../../domain/codecs/form/RoadblockForm";

export type TAwaitEntityGroup = {
    category: TRoadblockAwaitableEntityCategory;
    entities: Array<TRoadblockAwaitableEntity>;
};

// An entity matches on a substring of its display name or on the *prefix* of any alias.
// Alias matching is prefix-only on purpose: aliases are two-to-four character shorthands
// ("lr", "la", "ea"), and substring-matching them makes almost every query hit almost
// every entity.
export const matchesAwaitQuery = (entity: TRoadblockAwaitableEntity, query: string): boolean => {
    const q = query.trim().toLowerCase();

    if (q === "") {
        return true;
    }

    return entity.name.toLowerCase().includes(q)
        || entity.aliases.some((alias) => alias.toLowerCase().startsWith(q));
};

export const groupAwaitEntities = (
    entities: Array<TRoadblockAwaitableEntity>,
): Array<TAwaitEntityGroup> =>
    pipe(
        RoadblockAwaitableEntityCategory_order,
        array.map((category) => ({
            category,
            entities: entities.filter((entity) => entity.category === category),
        })),
        array.filter((group) => group.entities.length > 0),
    );

export const flattenAwaitEntities = (
    groups: Array<TAwaitEntityGroup>,
    recents: Array<TRoadblockAwaitableEntity>,
): Array<TRoadblockAwaitableEntity> => [
    ...recents,
    ...pipe(groups, array.chain((group) => group.entities)),
];

export const resolveRecentEntities = (
    entities: Array<TRoadblockAwaitableEntity>,
    recentIds: Array<string>,
    limit: number,
): Array<TRoadblockAwaitableEntity> =>
    pipe(
        recentIds,
        array.filterMap((id) => option.fromNullable(entities.find((entity) => entity.id === id))),
        array.takeLeft(limit),
    );
